import styled from 'styled-components';

export const Products = styled.ul`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    column-gap: 3.645833333333333vw;
    row-gap: 4.0625vw;
`;
